import React from 'react';
import PropTypes from 'prop-types';
import NavigationItem from './NavigationItem.js';
import betaBadge from './images/beta.svg';
import { setCookie } from 'utils/cookie';
import './style.css';

const propTypes = {
  allowModules: PropTypes.array,
  userPermission: PropTypes.array,
  isPermissionLoaded: PropTypes.bool,
  modules: PropTypes.objectOf(PropTypes.shape({
    rootUrl: PropTypes.string.isRequire,
    text: PropTypes.string.isRequire,
  })).isRequired,
  isAdmin: PropTypes.bool,
  isLoggedIn: PropTypes.bool.isRequired,
  onNavigationItemClick: PropTypes.func,
  filterModule: PropTypes.func,
};
const defaultProps = {
  allowModules: [],
  userPermission: [],
  isPermissionLoaded: false,
  modules: {},
  filterModule: () => false,
};

export default function Navigation({ allowModules, userPermission, isPermissionLoaded, modules, isAdmin, isLoggedIn, onNavigationItemClick, filterModule }) {
  const currentPath = location.pathname;
  // 跨網域的站台要帶著 XE 目前的語系過去，同首頁開啟 MAYO Form 的作法。
  // path 給 '/'：header 在所有頁面都會出現，不指定的話 cookie 會落在當下的路徑底下，
  // 在 /tube/companyspace 這類深層頁面點擊時對方站台會讀不到。
  const handleItemClick = module => (event) => {
    if (module.syncLocale) {
      setCookie('locale', sessionStorage.getItem('locale') || 'zh-TW', undefined, '.mayohr.com', '/');
    }
    if (onNavigationItemClick) {
      onNavigationItemClick(event);
    }
  };
  const navigationItem = Object.keys(modules).map((moduleName) => {
    const module = modules[moduleName];
    // 宣告 requirePermission 的模組改由 permissions API 決定，不看 userInfo 的 userModule
    const isAllowed = module.requirePermission
      ? userPermission.indexOf(module.requirePermission) !== -1
      : allowModules.indexOf(moduleName) !== -1;
    if (!isAllowed || filterModule(moduleName)) {
      return undefined;
    }
    const modulePath = new RegExp(module.activePathRegExp, 'i');
    const excludePath = new RegExp(module.excludePathRegExp, 'i');
    return (
      <NavigationItem
        key={moduleName}
        rootUrl={module.rootUrl}
        text={module.text}
        target={module.target}
        active={modulePath.test(currentPath) && !excludePath.test(currentPath)}
        onNavigationItemClick={handleItemClick(module)}
        badge={
          module.isBeta
            ? <img className="site-navigation__item-link-badge" src={betaBadge} alt="Beta" />
            : null
        }
      />
    );
  });
  return (
    <div className="site-navigation ">
      {
        // 等 permission 到齊才渲染模組列：JobHub 的顯示條件來自 permissions API，
        // 比 userInfo 晚回來，先渲染會讓它晚一步插入而把右邊的項目往右推。
        // 外層 40px 的底色列先撐住高度，所以只是項目一次到齊，不會有高度跳動。
        isLoggedIn && isPermissionLoaded
        && (
          <div className="container clearfix">
            <ul className="site-navigation__list pull-left">
              { navigationItem }
            </ul>
            {
              isAdmin && (
                <ul className="site-navigation__list pull-right">
                  <NavigationItem
                    rootUrl="/tube/companyspace/permission"
                    text="Company Space"
                    active={(/(Tu0101|tube\/companyspace)/i).test(currentPath)}
                    onNavigationItemClick={onNavigationItemClick}
                  >
                    <i className="fa fa-th-large site-navigation__item-link-icon"/>
                  </NavigationItem>
                </ul>
              )
            }
          </div>
        )
      }
    </div>
  );
}

Navigation.propTypes = propTypes;
Navigation.defaultProps = defaultProps;



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/components/Navigation/index.js
 **/